import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  to?: string;
}

const Logo = ({ className, size = "md", to }: LogoProps) => {
  const config = {
    sm: { text: "text-lg" },
    md: { text: "text-xl" },
    lg: { text: "text-2xl" }
  }[size];

  const content = (
    <span className={cn(
      "font-sans font-bold tracking-tight bg-black text-white px-2 py-0.5 rounded",
      config.text
    )}>
      sendfeedback.ai
    </span>
  );

  if (to) {
    return (
      <Link to={to} className={cn("transition-all duration-300 hover:opacity-80", className)}>
        {content}
      </Link>
    );
  }

  return (
    <div className={cn("transition-all duration-300", className)}>
      {content}
    </div>
  );
};

export default Logo;
